// ** Store Imports
import { handleBgColor } from "@store/layout/layout";
import { useDispatch, useSelector } from "react-redux";

export const useBgColor = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const store = useSelector((state) => state.layout);

  const setBgColor = (type) => {
    dispatch(handleBgColor(type));
    document.documentElement.setAttribute("tuneIn-theme", type);
    localStorage.setItem("tuneIn_theme", type);
  };

  return { bgColor: store.bgColor, setBgColor };
};
